<!--eslint-disable no-mixed-spaces-and-tabs-->
<template>
    <div class="border rounded-4 mb-3 tank-card border-contrast" v-if="Object.keys(props.value).length > 0">
        <div
            :id="`tooltip-button-${props.value.id}`"
            class="text-dark small fw-bold text-center mt-2 mb-2 position-relative tank-title"
            style="min-height: 40px;"
        >
            <font-awesome-icon :icon="faTag"/>
            <span
                class="pointer ms-2"
                v-b-tooltip.hover.title="text"
                @click="copyTag(props.value.tag)"
            >
                        <span v-if="props.value.tag && props.value.tag.includes('SOMA')">TANQUE SOMA</span>
                <span v-else>{{ props.value.tag }}</span>
            </span>
            <div
                v-if="props.value.abruptChange"
                class="abrupt-change-badge"
            >
                <font-awesome-icon
                    :icon="faChartLine"
                    class="pulse-icon"
                />
                Variação Abrupta
                <span class="badge-text">{{ props.value.abruptChangePercentage?.toFixed(0) }}%</span>
            </div>
                        </div>

        <div
            class="position-relative d-flex flex-column align-items-center"
            style="height: 180px;"
        >
            <!-- Tampa -->
            <div
                class="w-70 h-4 bg-gradient-dark rounded-top-4 position-relative z-3 border border-dark shadow-strong"
                style="min-height: 15px;"
            >
                <div
                    class="position-absolute top-50 start-50 translate-middle w-60 h-2 d-flex justify-content-around align-items-center"
                >
                    <div
                        v-for="n in 3"
                        :key="n"
                        class="w-1 h-1 bg-dark rounded-circle border border-dark"
                    >
                    </div>
                </div>
            </div>

            <!-- Corpo do tanque -->
            <div
                class="w-70 h-30 bg-gradient-tank position-relative overflow-hidden border border-dark shadow-strong z-1"
                style="min-height: 80px;"
            >
                <div
                    class="position-absolute bottom-0 start-0 w-100 transition-all"
                    :style="{
                    height: `${alturaInicial}%`,
                    background: gradiente,
                    transition: `height 2s ease-out`
                }"
                >
                    <div
                        v-show="props.value.currentVolume > 0"
                        class="position-absolute top-0 start-0 w-200 h-3"
                    >
                        <div
                            class="position-absolute top-n2 start-0 w-200 h-100 bg-repeat-x bg-size-50 animate-wave-7s"
                        >
        </div>
                        <div
                            class="position-absolute top-n1 start-0 w-200 h-100 bg-repeat-x bg-size-40 animate-wave-5s opacity-40"
                        >
                        </div>
                    </div>
                </div>
                <div
                    class="position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center fw-bold fs-4 text-dark tank-percentage"
                >
                    {{ floatToDecimal((props.value.currentVolume / props.value.capacity) * 100) }}%
                </div>
            </div>

            <!-- Base cônica -->
            <div
                class="w-70 h-6 bg-gradient-dark clip-path-polygon border border-dark shadow-strong"
                style="min-height: 15px;"
            ></div>

            <!-- Suportes -->
            <div
                class="w-60 h-7 position-relative mt-n1"
                style="min-height: 15px;"
            >
                <div
                    class="position-absolute w-1-5 bg-gradient-dark rounded-bottom h-7 top-n0-5 perna-esquerda rotate-30"
                    style="min-height: 15px;"
                ></div>
                <div
                    class="position-absolute w-1-5 bg-gradient-dark rounded-bottom h-5 start-50 perna-central translate-middle-x top-1"
                    style="min-height: 15px;"
                ></div>
                <div
                    class="position-absolute w-1-5 bg-gradient-dark rounded-bottom h-7 top-n0-5 perna-direita rotate-n30"
                    style="min-height: 15px;"
                ></div>
            </div>
        </div>

        <div class="text-center mt-2 fw-bold text-dark">
            <span
                :class="[
                'd-inline-block w-3 h-3 rounded-circle me-2',
                status === 'normal' ? 'bg-success' :
                    status === 'atencao' ? 'bg-warning' :
                        'bg-danger'
            ]"
            ></span>
            <div style="min-height: 42px;">{{ tankContent.toUpperCase() }}</div>
            <br>
            <span
                :class="[
                'd-inline-flex align-items-center px-2-5 py-0-5 rounded-pill small fw-medium',
                props.value.productType === 'pa' ? 'bg-success bg-opacity-10 text-success' : 'bg-warning bg-opacity-30 text-default'
            ]"
            >
                {{ getProductType(props.value.productType) }}
            </span>
            <br>

            <div v-if="props.value.productDensity">
                {{ (props.value.currentVolume * props.value.productDensity).toFixed(2).replace('.', ',') }} /
                {{ (props.value.productDensity * props.value.capacity).toFixed(2).replace('.', ',') }}
                ton
            </div>
            <div
                v-else
                style="min-height: 20px;"
            ></div>
            <div>
                {{ floatToDecimal(props.value.currentVolume) }} / {{ floatToDecimal(props.value.capacity) }}
                {{ props.value.unit }}
            </div>

            <br>
            <span
                :class="[
                'small d-inline-flex align-items-center gap-1',
                isOutdated ? 'text-danger' : 'text-secondary'
            ]"
            >
                <font-awesome-icon
                    v-if="isOutdated"
                    :icon="faExclamationCircle"
                    class="text-danger"
                    size="lg"
                />
                <font-awesome-icon :icon="faClock"/>
                {{ props.value.updated }}
            </span>
        </div>
        <div class="col-12 pt-2 mb-2 mt-2 border-top border-gray">
            <div class="d-flex justify-content-around align-items-center">                
                <button
                    class="btn btn-sm btn-light rounded-circle p-2 d-flex align-items-center justify-content-center"
                    style="width: 36px; height: 36px; background-color: #dddddd;"
                    @click="viewDetails(props.value)"
                    v-b-tooltip.hover.title="'Ver detalhes do tanque'"
                > 
                    <font-awesome-icon icon="eye" class="fs-5 text-secondary" /> 
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref, onMounted } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faExclamationCircle, faClock, faTag, faChartLine } from '@fortawesome/free-solid-svg-icons';
import { floatToDecimal } from "./Dependencies/functions";
import moment from 'moment';

// Adicionando ref para controlar a altura inicial
const alturaInicial = ref(0);
let hasAlert = ref(false);
let text = ref('Clique para copiar o tag do tanque');

const props = defineProps({
    value: {
        type: Object,
        required: true
    },
    isFavorite: {
        type: Boolean,
        required: true
    },
});

// Adicionando onMounted para iniciar a animação
onMounted(() => {
    hasAlert.value = props.value.hasAlert;
    setTimeout(() => {
        alturaInicial.value = props.value.currentVolume / props.value.capacity * 100;
    }, 500);
});

const getProductType = (type) => {
    if (type == 'pa') {
        return 'Produto Acabado'
    }
    return 'Matéria Prima'
}

// Cores dos produtos
const coresProdutos = {
    soma: {
        1: '#2ecc71', // verde
        2: '#f1c40f', // amarelo
        3: '#e74c3c'  // vermelho
    },
    default: '#3498db' // azul
};

// Função para obter a cor base do tanque
const getCorBase = computed(() => {
    if (props.value.tag?.toUpperCase().includes('SOMA') && props.value.level > 0) {
        return coresProdutos.soma[props.value.level] || coresProdutos.default;
    }
    return coresProdutos.default;
});

// Função para converter cor hex para RGB
function hexToRgb(hex) {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    return [r, g, b];
}

// Computed para calcular o gradiente baseado no nível
const gradiente = computed(() => {
    const nivel = props.value.currentVolume;
    const corBase = getCorBase.value;
    const rgb = hexToRgb(corBase);

    if (nivel <= 20) {
        return `linear-gradient(to bottom, 
            rgba(${rgb[0]},${rgb[1]},${rgb[2]},0.7), 
            rgba(${Math.min(255, rgb[0] + 50)},${Math.max(0, rgb[1] - 30)},${Math.max(0, rgb[2] - 30)},1))`;
    } else if (nivel <= 50) {
        return `linear-gradient(to bottom, 
            rgba(${rgb[0]},${rgb[1]},${rgb[2]},0.65), 
            rgba(${Math.min(255, rgb[0] + 20)},${rgb[1]},${rgb[2]},1))`;
    } else {
        return `linear-gradient(to bottom, 
            rgba(${rgb[0]},${rgb[1]},${rgb[2]},0.7), 
            rgba(${rgb[0]},${rgb[1]},${rgb[2]},0.95))`;
    }
});

// Computed para calcular o status do tanque
const status = computed(() => {
    if (props.value.tag?.toUpperCase().includes('SOMA') && props.value.level > 0) {
        return props.value.level === 1 ? 'normal' :
            props.value.level === 2 ? 'atencao' : 'critico';
    }
    return 'normal';
});

const isOutdated = computed(() => {
    if (props.value.updated) {
        const [datePart, timePart] = props.value.updated.split(' ');
        const updatedTime = moment(`${datePart} ${timePart}`, 'DD/MM/YYYY HH:mm');
        const currentTime = moment();
        const diffInMinutes = currentTime.diff(updatedTime, 'minutes');
        return diffInMinutes > 60;
    } else {
        return null;
    }
});

const tankContent = computed(() => {
    if (props.value.content.includes("AlumÃ­nio")) {
        const str = props.value.content.replace("AlumÃ­nio", "Alumínio");
        return str;
    } else {
        return props.value.content
    }
});

const emit = defineEmits(["removeFavorite", "addFavorite", "changeAlert", "viewDetails"]);

const favorite = (value) => {
    if (props.isFavorite) {
        emit('removeFavorite', value)
    } else {
        emit('addFavorite', value)
    }
}

function emitChangeAlert(tank) {
    hasAlert.value = !hasAlert.value;
    emit('changeAlert', tank, hasAlert.value);
}

function viewDetails(tank) {
    emit('viewDetails', tank);
}

const copyTag = (tag) => {
    navigator.clipboard.writeText(tag).then(() => {
        text.value = 'Tag copiada!';
        setTimeout(() => {
            text.value = 'Clique para copiar o tag do tanque';
        }, 2000);
    }).catch(err => {
        console.error('Erro ao copiar a tag: ', err);
        text.value = 'Erro ao copiar';
        setTimeout(() => {
            text.value = 'Clique para copiar o tag do tanque';
        }, 3000);
    });
};
</script>

<style scoped>

.bg-opacity-10{
    background-color: #2ecc71 !important;
}

.bg-opacity-30{
    background-color: #f1c40f !important;
}

.text-success{
    color: #ffffff !important;
    font-weight: 600 !important;
}

.text-default{
    color: #212529 !important;
}

/* Classes de dimensão reduzidas */
.w-70 {
    width: 70%;
}

.w-60 {
    width: 60%;
}

.w-200 {
    width: 200%;
}

.w-1 {
    width: 0.25rem;
}

.w-1-5 {
    width: 0.375rem;
}

.h-1 {
    height: 0.25rem;
}

.h-2 {
    height: 0.5rem;
}

.h-3 {
    height: 0.75rem;
}

.h-4 {
    height: 1rem;
}

.h-5 {
    height: 1.25rem;
}

.h-6 {
    height: 1.5rem;
}

.h-7 {
    height: 1.75rem;
}

.h-30 {
    height: 7.5rem;
}

/* Classes de posicionamento ajustadas */
.top-n2 {
    top: -0.5rem;
}

.top-n1 {
    top: -0.25rem;
}

.top-n0-5 {
    top: -0.125rem;
}

/* Classes de rotação */
.rotate-30 {
    transform: rotate(30deg);
}

.rotate-n30 {
    transform: rotate(-30deg);
}

/* Classes de padding */
.px-2-5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
}

.py-0-5 {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
}

/* Classes de background */
.bg-size-50 {
    background-size: 50% 100%;
}

.bg-size-40 {
    background-size: 40% 100%;
}

/* Gradientes com tons de cinza mais claros */
.bg-gradient {
    background: linear-gradient(to bottom right, #e9ecef, #dee2e6, #e9ecef) !important;
    background-image: linear-gradient(to bottom right, #e9ecef, #dee2e6, #e9ecef) !important;
}

.bg-gradient-dark {
    background: linear-gradient(to bottom right, #ced4da, #adb5bd, #ced4da) !important;
    background-image: linear-gradient(to bottom right, #ced4da, #adb5bd, #ced4da) !important;
}

.bg-gradient-tank {
    background: linear-gradient(to bottom right, #f8f9fa, #e9ecef, #f8f9fa) !important;
    background-image: linear-gradient(to bottom right, #f8f9fa, #e9ecef, #f8f9fa) !important;
}

/* Melhor contraste para bordas e sombras com cinza mais claro */
.border-contrast {
    border: 2px solid #c9cbcd !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

.border-dark {
    border-color: #adadad !important;
}

.shadow-strong {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
}

.bg-dark {
    background-color: #6c757d !important;
}

/* Melhor contraste para o título do tanque */
.tank-title {
    background: linear-gradient(to right, #f8f9fa, #ffffff, #f8f9fa);
    border-radius: 0.5rem;
    border: 1px solid #dee2e6;
    margin: 0.5rem;
    padding: 0.5rem;
    color: #212529 !important;
    font-weight: 600 !important;
}

/* Melhor contraste para o percentual */
.tank-percentage {
    color: #212529 !important;
    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8);
    font-weight: 700 !important;
}

/* Classe para clip-path */
.clip-path-polygon {
    clip-path: polygon(0% 0%, 100% 0%, 80% 100%, 20% 100%);
}

/* Modo escuro - cores mais suaves */
[data-layout-mode="dark"] .tank-card {
    background-color: #2a3042 !important;
    border-color: #8692a6 !important;
}

[data-layout-mode="dark"] .tank-title {
    background: linear-gradient(to right, #32384e, #3b3f4c, #32384e);
    border-color: #8692a6;
    color: #e9ecef !important;
}

[data-layout-mode="dark"] .tank-percentage {
    color: #212529 !important;
    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.9);
}

[data-layout-mode="dark"] .bg-gradient-dark {
    background: linear-gradient(to bottom right, #8692a6, #74788d, #8692a6) !important;
}

[data-layout-mode="dark"] .bg-gradient-tank {
    background: linear-gradient(to bottom right, #495057, #3b3f4c, #495057) !important;
}

[data-layout-mode="dark"] .border-contrast {
    border-color: #8692a6 !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
}

/* Animações */
@keyframes wave {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-50%);
    }
}

.animate-wave-7s {
    animation: wave 7s linear infinite;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 30' preserveAspectRatio='none'%3E%3Cpath fill='%23ffffff' opacity='0.5' d='M0,15 Q150,5 300,15 T600,15 T900,15 T1200,15 V30 H0 Z' /%3E%3C/svg%3E");
}

.animate-wave-5s {
    animation: wave 5s linear infinite;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 30' preserveAspectRatio='none'%3E%3Cpath fill='%23ffffff' opacity='0.3' d='M0,15 Q150,5 300,15 T600,15 T900,15 T1200,15 V30 H0 Z' /%3E%3C/svg%3E");
}

.perna-esquerda {
    left: 0.0rem;
    top: -0.5rem;
}

.perna-direita {
    right: 0.0rem;
    top: -0.5rem;
}

.perna-central {
    height: 1.6rem;
    top: 0.3rem;
}

.rounded-top-4 {
    border-top-left-radius: 80%;
    border-top-right-radius: 80%;
}

.border-gray {
    border-color: oklch(87.2% .01 258.338);
}

.shadow {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, #0000001a), 0 4px 6px -4px var(--tw-shadow-color, #0000001a) !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
}

.tank-card {
    box-shadow: 0 0 10px 0 #a9a9a9;
    background-color: #fcfcfc;
}

[data-layout-mode="dark"] .tank-card {
    background-color: #1a1a1a;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

[data-layout-mode="dark"] .tank-card .text-dark {
    color: #d4d4d4 !important;
}

[data-layout-mode="dark"] .tank-card .text-secondary {
    color: #8d8d8d !important;
}

[data-layout-mode="dark"] .tank-card .text-warning {
    color: #8d8d8d !important;
}

[data-layout-mode="dark"] .tank-card .text-success {
    color: #8d8d8d !important;
}

[data-layout-mode="dark"] .bg-gradient {
    background: linear-gradient(to bottom right, #1a1a1a, #212529, #1a1a1a) !important;
    background-image: linear-gradient(to bottom right, #1a1a1a, #212529, #1a1a1a) !important;
}

/* Animação pulsante para variação abrupta */
@keyframes pulse {
    0% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
    }
}

.abrupt-change-badge {
    position: absolute;
    top: -20px;
    right: -8px;
    background: linear-gradient(45deg, #dc3545, #c82333);
    color: white;
    border-radius: 12px;
    padding: 2px 6px;
    font-size: 0.65rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 2px;
    animation: pulse 2s ease-in-out infinite;
    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.4);
    z-index: 10;
    min-width: 35px;
    justify-content: center;
}

.pulse-icon {
    font-size: 0.6rem;
    animation: pulse 1.5s ease-in-out infinite;
}

.badge-text {
    font-size: 0.6rem;
    font-weight: bold;
}

.pointer {
    cursor: pointer;
}
</style>
